import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MainTitle } from '../../../common/index.jsx';
import FormTextField from '../../../antd/form/FormTextField/FormTextField.jsx';
import FormSelect from '../../../antd/form/FormSelect/FormSelect.jsx';
import FormTextArea from '../../../antd/form/FormTextArea/FormTextArea.jsx';
import { email, required } from '../../../antd/form/FormValidation.js';
import FormButton from '../../../antd/form/FormButton/FormButton.jsx';
import FormButtonsContainer from '../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import Form from '../../../antd/form/Form/Form.jsx';
import { useTranslation } from 'react-i18next';

const ContactForm = ({ form, categoryOptions, initialValues, onFinish }) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.location.pathname === '/contact' &&
      i18n.language !== 'en'
    ) {
      i18n.changeLanguage('en');
    }
  }, []);

  // State just to mark reCAPTCHA readiness
  const [, setGrecaptchaReady] = useState(false);

  // Načítanie reCAPTCHA skriptu
  useEffect(() => {
    let script;

    if (!window.grecaptcha) {
      script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${import.meta.env.VITE_RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        window.grecaptcha.ready(() => setGrecaptchaReady(true));
        // Zobraz badge ak existuje
        const badge = document.querySelector('.grecaptcha-badge');
        if (badge) badge.style.display = '';
      };
      document.body.appendChild(script);
    } else {
      window.grecaptcha.ready(() => setGrecaptchaReady(true));
      // Zobraz badge ak existuje
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) badge.style.display = '';
    }

    return () => {
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) badge.style.display = 'none';
      if (script) document.body.removeChild(script);
    };
  }, []);

  // Skry ikony pri zobrazení Form
  useEffect(() => {
    const elements = document.getElementsByClassName(
      'application-questions-container',
    );
    const prevDisplays = [];
    for (let i = 0; i < elements.length; i++) {
      prevDisplays[i] = elements[i].style.display;
      elements[i].style.display = 'none';
    }
    return () => {
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = prevDisplays[i] || '';
      }
    };
  }, []);

  const handleFinish = (values) => {
    if (!window.grecaptcha) {
      onFinish({ ...values, captchaResponse: '' });
      return;
    }

    window.grecaptcha.ready(() => {
      // reCAPTCHA execute vracia Promise s tokenom
      window.grecaptcha
        .execute(import.meta.env.VITE_RECAPTCHA_SITE_KEY, { action: 'contact' })
        .then((token) => {
          onFinish({ ...values, captchaResponse: token });
        });
    });
  };

  return (
    <Form form={form} onFinish={handleFinish} initialValues={initialValues}>
      <MainTitle title={t('Napíšte nám')} />

      <FormTextField
        label={t('Meno a priezvisko')}
        name={'name'}
        rules={[required(t)]}
      />

      <FormTextField
        label={t('E-mailová adresa')}
        name={'email'}
        rules={[required(t), email(t)]}
      />

      <FormTextField
        label={t('Predmet')}
        name={'subject'}
        rules={[required(t)]}
      />

      <FormSelect
        label={t('Kategória')}
        name={'category'}
        rules={[required(t)]}
        options={categoryOptions}
      />

      <FormTextArea
        label={t('Text správy')}
        name={'text'}
        rules={[required(t)]}
        rows={'6'}
      />

      <FormButtonsContainer>
        <FormButton submitOnClick={true} submitKey={'contact'}>
          {t('Odoslať otázku')}
        </FormButton>
      </FormButtonsContainer>
    </Form>
  );
};

ContactForm.propTypes = {
  categoryOptions: PropTypes.any,
};

export default ContactForm;
